import {
  HEADER_ERROR,
  RESET_HEADER_OBJ,
  GET_CSAT,
  SET_CSAT,
  SET_HEADER_INDICATORS,
} from "./actionTypes";

const initialState = {
  indicators: {
    open: 0,
    waiting: 0,
    overdue: 0,
    bursting: 0,
    csat: "-",
  },
  status: {},
};

const Header = (state = initialState, action) => {
  switch (action.type) {
    case HEADER_ERROR:
      state = {
        ...state,
        status: {
          ...state?.status,
          [action?.payload?.action]: {
            error: {
              status: true,
              message: action?.payload?.message,
            },
            loading: false,
            success: false,
          },
        },
      };
      break;
    case RESET_HEADER_OBJ:
      state = initialState;
      break;
    case GET_CSAT:
      state = {
        ...state,
        status: {
          ...state?.status,
          get_csat: {
            error: false,
            loading: true,
            success: false,
          },
        },
      };
      break;
    case SET_CSAT:
      state = {
        ...state,
        indicators: {
          ...state?.indicators,
          csat: action?.payload,
        },
        status: {
          ...state.status,
          get_csat: {
            error: false,
            loading: false,
            success: true,
          },
        },
      };
      break;
    case SET_HEADER_INDICATORS:
      state = {
        ...state,
        indicators: {
          ...state?.indicators,
          open: action.payload.open,
          waiting: action.payload.waiting,
          overdue: action.payload.overdue,
          bursting: action.payload.bursting,
        },
      };
      break;
    default:
      // do nothing
      break;
  }
  return state;
};

export default Header;
